module.exports = __webpack_public_path__ + "img/avatar.b8d92d86.svg";